import { useEffect, useCallback, useRef, useContext } from 'react';
import { BoardContext } from '../context';

const useSound = () => {
    const { soundVolume } = useContext(BoardContext);
    const audio = useRef(new Audio());
  
    const playSound = useCallback((url: string) => {
      const audioUrl = process.env.REACT_APP_BACKEND_URL?.concat(url);
      audio.current = new Audio(audioUrl);
      audio.current.volume =soundVolume; // only music in phase 3.
      audio.current.play();
    }, [soundVolume]);

    const stopSound = useCallback(() => {
      audio.current.pause();
    }, []);

    useEffect(() => {
        audio.current.addEventListener('ended', stopSound);
  
        return () => { 
            audio.current.removeEventListener('ended', stopSound);
        };
    }, [stopSound]);

    audio.current.volume = soundVolume; // slot machine, I find 0.05 pretty plesant, and find to hear on computer's max volume during the game, hovering cards, clicking on cards, wheel of fortune, selecting solution card from the table, yuppy 
  
    return {playSound, stopSound};
  }

  export default useSound;